import {accessTokenLocalStorageKey} from '../../constants';
import storage from '../../fetchApi/storage';

export default (role) => {
  const token = storage.load(accessTokenLocalStorageKey);

  return !!(token && token.highestRole === role);
};